import React, { useState } from 'react';
import shafaLogo from '../../../assets/img/shefa-logo.svg'
import LoginForm from '../../Login/LoginForm/LoginForm'
import Util from "../../../utils/utils"
import { Redirect } from "react-router-dom";


function LoginPage ()
{
	const token = Util.getSession( "token" );
	const state = Util.getSession( "state" );
	let type;
	const [ redirectState, redirectSetState ] = useState( { "redirect" : false, "url" : "" } );

	if ( !token || token === "undefined" || token === null )
	{

		if ( token === undefined || token === null )
		{
			Util.clearSession( "token" )
		}

		if ( !state )
		{
			type = "login";
			window.history.pushState( '', '', "/login" );
		}
		else if ( state === 1 )
		{
			type = "verify";
			window.history.pushState( '', '', "/verify" );
		}
		else if ( state === 2 )
		{
			type = "email-login";
			window.history.pushState( '', '', "/email-login" );
		}

	}
	else
	{
		window.location.href = "/"
		// return <Redirect to="/"/>;
	}

	if ( redirectState.redirect )
	{
		redirectSetState( { "redirect" : false } );
		window.history.pushState( '', '', redirectState.url );
		return <Redirect to={redirectState.url}/>;
	}

	Util.convertNumberToPersion(document.body);

	return (
		<main className="h-100 pb-0">
			<section className="col-sm-12 row m-0 p-0 login-section">
				<div className="col-12 m-0 p-0 login-div">
					<div className="col-12 row m-0 p-0">
						<div className="login-logo">
							<img src={shafaLogo} alt="shefaLogo"/>
						</div>
					</div>
					<div className="col-12 m-0 p-0">
						<LoginForm type={type} redirectSetState={redirectSetState}/>
					</div>
				</div>
			</section>
		</main>
	);

}


export default LoginPage;
